import type { NavigateFunction } from "react-router-dom";
import { routesArray } from "../../app/routing/routes";
import type { ServiceLinksType } from "../../common/Header/types";

export const navigateToRoute = (
  links: ServiceLinksType,
  navigate: NavigateFunction
) => {
  const activePath = window.location.pathname;

  if (
    activePath &&
    links.find((item) => item === activePath || activePath.startsWith(item))
  ) {
    navigate(activePath);
  } else {
    const firstUrl =
      links.find((group) =>
        routesArray?.children?.some((route) => route.path === group)
      ) || "/";
    navigate(firstUrl);
  }
};
